<template>
  <div class="">
    <!-- Max Execution Time Error -->
    <div class="card premium-bg mb-3 hidden" id="max-execution-time-alert" v-if="currentJob.apiJob.errors[0].code === 6020">
      <div class="card-header no-border text-white">
        <span class="font-weight-bold font-size-150 gap-15 d-flex align-items-center"><i class="far fa-clock"></i> {{getMaxExecutionTitle()}}</span>
      </div>
      <div class="card-body text-white">
        <p class="font-size-125" v-if="isFreeUser">
          {{ "Get %project% Premium to increase your processing time per task." | trans({'%project%': this.projectName}) }}
        </p>
        <button v-if="isFreeUser" class="btn btn-warning font-weight-bold payment-btn" @click="openPremium">{{ "Go Premium" | trans }} <i class="fa fa-arrow-right"></i></button>
        <a id="payment-redo-btn" class="btn btn-default font-weight-bold" href="#" @click="openGoBack"><i class="fa fa-redo"></i> {{ "Go back and try another file" | trans }}</a>
      </div>
      <div class="card-footer no-border text-white" v-if="isFreeUser">
        <i class="far fa-info-circle pr-1"></i>
        {{ "Processing tasks for a long time costs a lot of server resources and is only possible for paying users." | trans }}
      </div>
    </div>

    <!-- Normal Error -->
    <div class="p-2 bg-white border rounded"> 
      <div class="alert alert-danger pt-4 mb-0"> 
        <p><strong><i class="lh-inherit far fa-info-circle"></i> {{ 'Something went wrong' | trans}}</strong></p> 
        <p>{{ this.getTranslatedError(currentJob.apiJob.errors[0].code) }}</p> 
      </div> 
    </div> 
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import user from './../../mixins/user.mixin'
import {EventBus} from "../../events/event.bus";
import {EVENT_SHARE} from "../../events/app.events";
import {satGlobals} from "../../../../../../sat/helper/sat-globals";
import Analytics from "../../util/Analytics";
import {
  registerPaymentModalHelper
} from "../../../../../../../lib-sat/user/modal/register_payment_flow/register-payment-modal-helper";

export default {
  name: "Error",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
      user,
  ],
  data() {
    return {
      projectName: satGlobals.getProjectName(),
      errors : {
        6000: 'Something went wrong while converting your file.',
        6001: 'Your file is DRM protected and therefore we are not allowed to convert it.',
        6002: 'The file is password protected. Please provide the password.',
        6004: 'Unfortunately, we can not convert your source file format to the target file format.',
        6005: 'Your file is missing important metadata and therefore we can not convert it.',
        6006: 'The files inside an archive must be of the same type.',
        6011: 'The file is password protected. Please provide the password.',
        6012: 'There was a temporary error with your conversion. Please try again later. We had a problem on our side. Normally it is auto fixed in a few seconds.',
        6018: 'The file seems to be broken and we are unable to fix it.',
        6019: 'Your file uses an unsupported encryption format.',
        6020: 'Your conversion took too long and was canceled.',
        6021: 'Width or height exceed the limit for icons. Please make sure the largest side is set to max 256px.',
        6022: 'There has been an error converting your file.',
        6023: 'The job has an input file which is too old.',
        6024: 'We could not compress this file any further.',
        6026: 'Width or height exceed the limit for AI upscaling. Please make sure the largest side is set to max 2000px.',
        6029: 'The input file is not a valid PDF.',
        6030: 'All slides in the presentation are marked as hidden.',
        6031: 'We could not automatically create a PDF/A from your document. Some of the elements within your PDF may be incompatible with your selected PDF/A standard. Please try converting your file to another PDF/A standard.',
        6032: 'We could not automatically create a PDF/A from your document. Some of the elements within your PDF may be incompatible with your selected PDF/A standard. Please try converting your file to another PDF/A standard.',
        6033: 'We could not automatically create a PDF/A from your document. Some of the elements within your PDF may be incompatible with your selected PDF/A standard. Please try converting your file to another PDF/A standard.',
        6035: 'We could not automatically create a PDF/A from your document. Some of the elements within your PDF may be incompatible with your selected PDF/A standard. Please try converting your file to another PDF/A standard.',
        6036: 'We are not able to extract any embedded assets from the file.',
        6037: 'The image size you selected exceeds the maximum of %max_allowed_size% pixels. You can either resize it or choose an other format like PNG, which supports larger dimensions.',
        6038: 'The resulting duration of the converted video is too long (>4 hrs).',
        6039: 'Please, retry the conversion without the OCR option.',
        6046: 'The input file is not compliant with the selected PDF/A validation profile.',
        6047: 'There has been an error validating your file.',
        6048: 'Please, retry the conversion without the OCR option.',
        6049: 'Please, retry the conversion with the OCR option.',
        6051: 'There has been an error validating your file.',
        6052: 'We could not extract any text from your file.',
        6053: 'We could not extract any audio from your file.',
        6054: 'AI upscale cannot be used to downscale an image.',
        6056: 'We are not able to extract any embedded assets from this file format yet.',
        6057: 'Your file cannot be converted to the selected PDF/A standard while in non-strict mode.',
        20000: 'Unfortunately, we detected an issue during the conversion. We converted your file as best as possible, but it might be only partially converted. Please check it manually.',
        20003: 'Unfortunately, we can not convert your source file format to the target file format.',
        20004: 'The rendered output may be incorrect.',
        20005: 'Your file uses an unsupported encryption format.',
        20006: 'The DPI value may be incorrect.',
        20007: 'We could not compress this file any further.',
        20008: 'The version of the converted file has been downgraded.',
        20009: 'It was not possible to preserve transfer functions in PDF 2.0.',
        20011: 'The value for the audio frequency is too low. The conversion used the lowest possible value allowed. You can also try again with a higher value or with a different codec.',
        20012: 'The value for the audio frequency is too high. The conversion used the highest possible value allowed. You can also try again with a smaller value or with a different codec.',
        20013: 'The value for the audio frequency is not allowed. The conversion used the highest possible value allowed. You can also try again with another value or with a different codec.',
        20014: 'The sizes of the reference image and the compared image do not match. The result can be inaccurate.',
        20015: 'The sizes of the reference video and the compared video do not match. The result can be inaccurate.',
        20016: 'The codec of the input file does not fit the video codec. A different one was chosen.',
        20018: 'The width or height exceed the limit for AI upscaling for your file. The maximum possible size is provided.',
        20022: 'During compression we detected a larger quality degradation. Please check the result.',
        ocr_needed: 'Your file could not be converted, please retry the conversion with the OCR option enabled.',
        6058: 'AI upscale percentage out of range. It should be between 101 and 400.',
        6067: 'We could not detect any faces in your file.',
        premium_limit_reached: 'You have reached the limitations of your account.',
      }
    };
  },
  mounted: function () {

  },
  created: function () {
  },
  methods: {
    async openGoBack() {
      await Analytics.send('result_action', 'error_max_exec_time_go_back', this.currentJob);

      window.location.href = this.currentJob.apiJob.sat_links.redo.href.link;
    },
    async openPremium() {
      await Analytics.send('result_action', 'error_max_exec_time_open_premium', this.currentJob);

      registerPaymentModalHelper.openUpgrade().then(() => {
        this.modalToShow = null;
      });
    },
    getTranslatedError(code) {
      if (typeof this.errors[code] !== 'undefined') {
        if (code === 6037) {
          return this.translate('The image size you selected exceeds the maximum of %maxAllowedSize% pixels. You can either resize it or choose an other format like PNG, which supports larger dimensions.' , {
            '%maxAllowedSize%': this.currentJob.apiJob.errors[0].details.max_allowed_size
          });
        }

        return this.translate(this.errors[code]);
      }

      return this.translate(this.errors[6000]);
    },
    getMaxExecutionTitle() {
      if (this.currentJob.apiJob.sat.constraints.job?.api?.max_process_time < 0) {
        return this.translate(this.errors[6020]);
      }

      let maxTime =  Math.ceil((this.currentJob.apiJob.sat.constraints.job?.api?.max_process_time ?? 0) / 60);
      return this.translate('Your task took more than %time% minutes to process', {'%time%': maxTime})
    }
  },
  computed: {
    
  }
};
</script>
<style lang="scss" scoped>

</style>
